<template>
  <v-toolbar dense flat height="42" class="default-header">
    <v-container class="px-0">
      <v-row align="center" class="d-flex text-center flex-wrap">
        <v-btn icon height="35" width="35" color="primary" @click="goBack()">
          <v-icon class="tooltitle">mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title
          class="tooltitle white--text font-weight-bold pl-0 body-2 text-capitalize"
          style="max-width: calc(100% - 140px)"
        >
          {{ title }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <favorite-btn
          v-if="favoriteBtn"
          :is-favorite="isFavorite"
          :market-id="marketId"
          :favorite="event && event"
        />
        <!-- <a
          v-if="
            title === 'Choose Withdrawal Method' ||
            title === 'Choose Deposit Method'
          "
          href="/referral"
          class="border-referral"
        >
          <v-img
            :src="require('@/assets/images/referandearn.png')"
            alt="Referral"
            max-width="100"
          ></v-img
        ></a> -->
        <v-btn
          v-if="liveBtn && $auth.loggedIn"
          x-small
          color="green"
          class="text-capitalize"
          @click="toggleShowLive()"
        >
          <span v-if="showLive">
            <v-icon size="14">mdi-close</v-icon>
            Hide
          </span>
          <span v-else>
            <v-icon size="14"> mdi-play-box-outline</v-icon>
            Watch
          </span>
        </v-btn>
        <!-- for betting pl -->
        <div class="caption-text font-weight-bold pr-2 d-lg-flex tool">
          <div v-if="totalPL" class="px-lg-2">
            Total P&amp;L :
            <span
              :class="{
                'success--text ': totalPL > 0,
                'error--text': totalPL < 0,
                'white--text ': totalPL == 0
              }"
              >{{ totalPL | currencyFormat(2) }}</span
            >
          </div>
          <div v-if="netcommision" class="px-lg-2">
            Total Net Commission :
            <span
              :class="{
                'success--text ': netcommision > 0,
                'error--text': netcommision < 0,
                'white--text ': netcommision == 0
              }"
              >{{ netcommision | currencyFormat(2) }}</span
            >
          </div>
        </div>
      </v-row>
    </v-container>
  </v-toolbar>
</template>
<script>
import FavoriteBtn from '@/components/FavoriteBtn'
export default {
  components: { FavoriteBtn },
  props: {
    title: { type: String, default: '', required: true },
    liveBtn: { type: Boolean, default: false, required: false },
    totalPL: { type: [String, Number], default: '', required: false },
    netcommision: { type: [String, Number], default: '', required: false },
    favoriteBtn: { type: Boolean, default: false, required: false },
    isFavorite: { type: Boolean, default: false, required: false },
    marketId: { type: String, default: '', required: false },
    dates: { type: Array, default: () => [], required: false },
    event: { type: Object, default: () => {}, required: false }
  },
  data() {
    return {
      showLive: false
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      if (this.$route.name === 'profit-loss-detail') {
        this.$router.push({
          path: '/profit-loss',
          query: { dates: this.dates }
        })
      }
    },
    toggleShowLive() {
      this.showLive = !this.showLive
      this.$listeners.liveBtnClick(this.showLive)
    }
  }
}
</script>
<style lang="scss">
.px-lg-2 {
  text-align: right;
}
.default-header {
  // margin-top: 16px;
  margin: 20px 4px 0px;
}
.mob-center {
  .page-title {
    max-width: calc(100% - 170px);
  }
}
.caption-text {
  font-size: 0.75rem;
}
@media only screen and (max-width: 768px) {
  .mob-center {
    button {
      position: absolute;
    }
    .page-title {
      max-width: 100% !important;
      width: 100%;
    }
  }
}
@media only screen and (max-width: 364px) {
  .page-title {
    max-width: 100% !important;
    width: 70% !important;
  }
  .tool {
    position: absolute;
    z-index: 0;
    width: 100%;
    display: grid;
  }
  .tooltitle {
    z-index: 1;
  }
  .pr-2 {
    text-align: right;
    align-items: flex-end;
  }
  .px-lg-2 {
    float: right;
    clear: none;
    align-self: right;
    margin: 0px 0px 0px 35px !important;
  }
}
@media only screen and (max-width: 280px) {
  .caption-text {
    font-size: 10px !important;
  }
}
</style>
